import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable";
import useApi from "../../core/customhook/useApi";

const FeedbackTeamMembers = () => {
  const [employee, setEmployee] = useState<any[]>([]);

  const {
    data: employeeData,
    loading,
    callApi: fetchEmployees,
  } = useApi("/api/manager/team-member", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (employeeData?.success) {
      const data = employeeData.data.map((item:any,index:any)=>{
        return {
          ...item,
          Sno : index+1
        }
      })
      setEmployee(data);
    }
  }, [employeeData]);

  const columns2 = [
    {
      title: "S.No.",
      dataIndex: "Sno",
      key: "Sno",
    },
    {
      title: "Employee ID",
      dataIndex: "employee_id",
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
    },
    {
      title: "Designation",
      dataIndex: "designation",
    },
    {
      title: "Department",
      dataIndex: "department",
    },
    {
      title: "Location",
      dataIndex: "branch_name",
    },
    // {
    //   title: "Joining Date",
    //   dataIndex: "join_date",
    // },
    {
      title: "Action",
      render: (_: any, record: any) => (
        <Link
          to={`/monthly-feedback/${record.employee_id}`}
          className="btn btn-primary btn-sm"
        >
          Give Feedback
        </Link>
      ),
    },
  ];
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Heading and Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Assessment</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Training Management</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Assessment
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          {/* Card Container */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
              <h5 className="mb-0">Assessment List</h5>
            </div>
            <div className="card-body">
              <div className="card table-responsive">
                <Table
                  dataSource={employee}
                  columns={columns2}
                  Selection={false}
                  showSearchInput={true}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default FeedbackTeamMembers;
